import { render } from "./SurchargeItem.vue?vue&type=template&id=77507faa&scoped=true&ts=true"
import script from "./SurchargeItem.vue?vue&type=script&lang=ts"
export * from "./SurchargeItem.vue?vue&type=script&lang=ts"

import "./SurchargeItem.vue?vue&type=style&index=0&id=77507faa&lang=scss&scoped=true"

import exportComponent from "/var/www/logiplanner_web_prod/logiplanner_web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-77507faa"]])

export default __exports__